/**
 * The external dependencies.
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormActivation from "components/form/FormActivation";

/**
 * @class      ModalActivation (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalActivation = (props) => {
  return (
    <ModalFrame>
      <FormActivation />
    </ModalFrame>
  );
};

export default ModalActivation;
